import api from './api.js';

/**
 * Fitness Spirals service wrapper
 */
class FitnessSpirals {

  /**
     * Constructor
     */
  constructor() {

    // Set URLs
    this.url = '/fitness-spirals';
    this.url_published = '/fitness-spirals/published';
  }

  /**
     * Get all Fitness Spirals
     * @param {*} params 
     * @return {Promise}
     */
  all(params = {}) {
    return api.get(this.url, params, true);
  }

  /**
     * Get all Fitness Spirals
     * @param {*} params
     * @return {Promise}
     */
  published(params = {}) {
    return api.get(this.url_published, params, true);
  }
}

export default new FitnessSpirals;
